define('Libraries', [
    'LPLeadboxes'
], function Libraries(
) {
    'use strict';
});
